module.exports = __webpack_public_path__ + "assets/img/Type E (81).97f78806.jpg";